import React, { useEffect } from 'react';

const Stack = () => {
  useEffect(() => {
    // Code for initializing any counter logic or animations if necessary
    const counters = document.querySelectorAll('.count');
    counters.forEach(counter => {
      const target = +counter.getAttribute('data-target');    
      let count = 0;
      const speed = 200; // Speed of counter increment

      const updateCount = () => {
        const increment = target / speed;
        if (count < target) {
          count += increment;
          counter.textContent = Math.ceil(count);
          setTimeout(updateCount, 1);
        } else {
          counter.textContent = target;
        }
      };
      updateCount();
    });
  }, []);

  return (
    <section className="counter-section stack">
      <div className="counter-row">
        {/* Left-aligned Counter 1 */}
        <div className="counter-item left">
          <h2><span className="count" data-target="25">25</span></h2>
          <h5>Years of Experience</h5>
        </div>

        {/* Vertical Line */}
        <div className="vertical-line"></div>

        {/* Centered Counter 2 */}
        <div className="counter-item center">
          <h2><span className="count" data-target="75">75</span><span style={{color:"rgb(8 137 145)"}}>MN</span></h2>
          <h5>Hours of Engineering</h5>
        </div>

        {/* Vertical Line */}
        <div className="vertical-line"></div>

        {/* Left-aligned Counter 3 */}
        <div className="counter-item left" style={{marginTop:"16px"}}>
          <h2><span className="count" data-target="250">250</span></h2>
          <h5>Design Concepts Proposed</h5>
        </div>

        {/* Vertical Line */}
        <div className="vertical-line"></div>

        {/* Centered Counter 4 */}
        <div className="counter-item center" style={{marginTop:"16px"}}>
          <h2><span className="count" data-target="2600">2,600</span></h2>
          <h5>Engineers with A&D Expertise</h5>
        </div>
      </div>

      <style>
        {`
        .counter-section.stack {
  padding: 50px 0;
  background-color: #fff;
  position: relative;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 20px; /* Rounded corners for the whole section */
  overflow: hidden; /* Ensures the children don't exceed the rounded corners */
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1); /* Added box shadow for the entire box */
}

          .counter-section {
                padding: 50px 0;
                background-color: #fff;
                position: relative;
                margin-left: 20px;
                margin-right: 20px;
                border-radius: 20px; /* Rounded corners for the whole section */
                overflow: hidden; /* Ensures the children don't exceed the rounded corners */
             }
          .counter-row {
            display: flex;
            justify-content: space-between; /* Space between items */
            align-items: center;
            gap: 30px;
            width: 100%;
            max-width: 1200px;
            flex-wrap: wrap;
            position: relative;
            z-index: 1;
            margin: 0 auto; /* Center align container */
          }

          .counter-item {
            text-align: center;
            flex: 1;
            min-width: 180px;
            max-width: 250px;
            // margin-bottom: 20px; 
          }

          .count {
            font-size: 50px;
            font-weight: bold;
            color: #088991;
          }

          h2 {
            margin-bottom: 10px;
          }

          h5 {
            color: #333;
            font-size: 16px;
            font-weight: normal;
          }

          .vertical-line {
            width: 2px;
            background-color: #088991;
            height: 80px; /* Adjusted the height of the line */
            margin: 0 20px;
          }

          /* Media Query for screens smaller than 768px */
          @media (max-width: 768px) {
            .counter-row {
              flex-direction: column;
              align-items: center;
            }

            .vertical-line {
              display: none; /* Hides the vertical lines on smaller screens */
            }

            .counter-item {
              width: 80%; /* Makes the counters take up more space on smaller screens */
              margin-bottom: 20px;
            }

            .count {
              font-size: 40px; /* Reduces font size on smaller screens */
            }

            h2 {
              font-size: 36px; /* Adjust the font size for the counters */
            }

            h5 {
              font-size: 14px; /* Adjust the font size for the descriptions */
            }
          }

          /* Media Query for screens smaller than 480px */
          @media (max-width: 480px) {
            .counter-item {
              width: 100%; /* Full width for even smaller screens */
              margin-bottom: 15px;
            }

            .count {
              font-size: 35px; /* Further reduce font size for very small screens */
            }

            h2 {
              font-size: 30px;
            }

            h5 {
              font-size: 12px;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Stack;
